import { BusinessCase } from '@schuettflix/interfaces';
import { useTranslation } from 'react-i18next';
import { PRODUCT_NAME_LABEL } from '@/phrase/ProductNameLabels.ts';

export function useSelectionTitle({ businessCase }: { businessCase: BusinessCase }) {
    const { t } = useTranslation();

    const isInclusiveTransport = !businessCase.isStandalone;
    let selectionTitle = t(PRODUCT_NAME_LABEL[businessCase.productType]);
    if (isInclusiveTransport) {
        selectionTitle = `${selectionTitle} ${t('salesforceDealImporter.templateSelection.inclTransport')}`;
    }

    return selectionTitle;
}
